/** Results per page for catalog catalog search (`c` param). */
export const CREATIVE_WORKS_SEARCH_PAGE_SIZE = 6;

/** Small page size for id / LCCN lookup searches. */
export const CREATIVE_WORKS_SEARCH_ID_LOOKUP_SIZE = 5;

export const CREATIVE_WORKS_CATALOG_API_ORIGIN = 'https://www.loc.gov';

export const CREATIVE_WORKS_SEARCH_PATH = '/search/';

/** catalog search payload: one page of hits plus pagination metadata. */
export const CREATIVE_WORKS_SEARCH_AT = 'pagination,results';

/** Item detail fields used on the item detail page. */
export const CREATIVE_WORKS_SEARCH_ITEM_AT = 'item,resources';
